import '/components/recently-viewed/recently-viewed';
import '/components/recently-viewed/recently-viewed.scss';
